import Text from "lib/components/Text"
import Collapsible from "@components/shared-components/ui/Collapsible"
import Markdown from "lib/components/Markdown/reader"
import _ from "lodash"
import { useContext } from "react"
import { LanguageContext } from "context/LanguageContext"
import { capitalize } from "lib/helpers"

interface SyllabusProps {
  type: string | string[]
  program_detail: {
    program_detail_syllabuses: [
      {
        content_type: string
        content_title: string
        content_detail: string
        day_index: number
        id: string
        content_summary: string
      },
    ]
  }
}
export default function Syllabus({ program_detail, type }: SyllabusProps) {
  const programDetailGroupBy = _.chain(program_detail?.program_detail_syllabuses)
    .groupBy("day_index")
    .map((value, key) => ({ day: key, syllabus: value }))
    .value()
  const { useTranslation: t, language } = useContext(LanguageContext)
  let prefixDay = ""
  if (language === "ID") {
    prefixDay = "ke-"
  }
  return (
    <div className="my-8">
      <Text size="large" color="dark" weight="semibold">
        {t("syllabus")}
      </Text>
      <div className="mt-4 flex flex-col space-y-2  rounded-t">
        {programDetailGroupBy.map(({ day, syllabus }, index) => (
          <div key={index}>
            <div className="h-14 rounded-t flex items-center px-4 bg-gray-100">
              {type === "public" || type === "inhouse" ? t("day") : t("week")}{" "}
              {`${prefixDay}${index + 1}`}
            </div>
            {syllabus.map(
              ({ content_type, content_title, content_detail, content_summary }, indexSyllabus) => (
                <div key={indexSyllabus} className="p-4 border border-gray-100">
                  <Collapsible
                    customClass="mt-4"
                    title={
                      <Text size="small" color="default" customClass="leading-5 ml-6" weight="bold">
                        {capitalize(content_type, "_")} : {content_title}
                      </Text>
                    }>
                    <div className="leading-4 ml-6 mt-4">
                      <Markdown>{content_summary}</Markdown>
                      <div className="mt-4" />
                      <Markdown>{content_detail}</Markdown>
                    </div>
                  </Collapsible>
                </div>
              ),
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
